/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspage_List_Title1Inputs */

const vi_cmspage_list_title1 = /** @type {(inputs: Cmspage_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang & câu chuyện`)
};

/**

* @param {Cmspage_List_Title1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_list_title1 = /** @type {((inputs?: Cmspage_List_Title1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_List_Title1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_list_title1(inputs)
});
export { cmspage_list_title1 as "cmsPage_list_title" }